import { file, prop, required } from '@rxweb/reactive-form-validators';

export class MediaModel {
	@file({ maxFiles: 1 })
	resource?: any;

	@prop({ name: 'resource_url' })
	resourceUrl: string;

	@required()
	name: string;

	@required()
	description: string;


	@prop({name: 'categories'})
    categories: any;
	@prop({name: 'client_id'})
    client_id: any;
	@prop()
	fecha: Date;

	@prop()
	vigencia: Date;

}
